import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-entry-comment',
  templateUrl: './entry-comment.component.html',
  styleUrls: ['./entry-comment.component.scss']
})
export class EntryCommentComponent implements OnInit {

  @Input() entryData: any;

  constructor() { }

  ngOnInit() {
    this.formatComment()
    this.formatSubtitle()
  }

  formatComment() {
    this.entryData.description = this.entryData.description.charAt(0).toUpperCase() + this.entryData.description.slice(1);
  }

  formatSubtitle() {
    const afterByIndex = this.entryData.subTitle.indexOf("by");
    this.entryData.formattedSubtitle = this.entryData.subTitle.slice(0, afterByIndex + 3)
    this.entryData.keyWorkerName = this.entryData.subTitle.slice(afterByIndex + 3)
  }

}
